
import Vuex from 'vuex'
import Vue from 'vue'
import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'
Vue.use(Vuex)

const state = {
  contract: null, // 当前处理的合同详情
  sealOut: null,
  auditList: {
    page: {
      list: [],
      viewtype: 'audit'
    }
  },
  ccList: {
    page: {
      list: [],
      viewtype: 'cc'
    }
  },
  historyList: {
    page: {
      list: [],
      viewtype: 'history'
    }
  },
  fileList: {
    page: {
      list: [],
      viewtype: 'file'
    }
  },
  sealList: {
    page: {
      list: [],
      viewtype: 'seal'
    }
  },
  mainmenupath: {
    viewtype: '',
    selected: -1
  }
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: []
})



// WEBPACK FOOTER //
// ./src/vuex/store.js